import { Component, Input } from '@angular/core';

@Component({
  selector: 'tracker-admin-alerts-assignee',
  template: require('./admin.alerts.assignee.component.html')
})
export class TrackerAdminAlertsAssigneeComponent {
  @Input() tracker: any;

  OnOff = {
    'On': 'Y',
    'Off': 'N'
  };

  setAssigneeEnabled(value: string) {
    this.tracker.settings.nagAlerts.assignee.isEnabled = value;
  }
}
